module.exports = __webpack_public_path__ + "img/kznb-app.06e7119b.png";